import React from "react";
import styles from "./InboxChat.module.css";
import { Link } from "react-router-dom";

interface InboxItemProps {
  unreadCount: number;
  senderName: string;
  messagePreview: string;
  profileImage: string;
  date: string;
  onClick: () => void; // Adicione isto
}

const InboxItem: React.FC<InboxItemProps> = ({
  unreadCount,
  senderName,
  messagePreview,
  profileImage,
  date,
  onClick, // Adicione isto
}) => {
  const handleItemClick = () => {
    console.log("Redirecionando para chat");
    onClick(); // Adicione isto
  };

  const MAX_MESSAGE_LENGTH = 60; // comprimento maximo da mensagem

  // Função para truncar a mensagem e adicionar reticências
  const truncateMessage = (message: string, maxLength: number) => {
    return message.length > maxLength
      ? `${message.substring(0, maxLength)}...`
      : message;
  };

  return (
    <Link
      to=""
      className={styles.inboxItem}
      onClick={handleItemClick}
      id="inboxItemLink"
    >
      <div className={styles.profileImage}>
        <img src={profileImage} alt={`${senderName}'s profile`} />
      </div>

      <div className={styles.content}>
        <div className={styles.header}>
          <span className={styles.senderName}>{senderName}</span>
          <aside className={`${styles.info} ${styles.mobile}`}>
          <span className={styles.sendDate}>{date}</span>
          {unreadCount > 0 && (
            <span className={styles.unreadCount}>{unreadCount}</span>
          )}
        </aside>
        </div>
        <div className={styles.mainContent}>
          <div className={styles.messagePreview}>
            {truncateMessage(messagePreview, MAX_MESSAGE_LENGTH)}
          </div>
            
        </div>
      </div>

      <aside className={`${styles.info} ${styles.desktop}`}>
        <span className={styles.sendDate}>{date}</span>
        {unreadCount > 0 && (
          <span className={styles.unreadCount}>{unreadCount}</span>
        )}
      </aside>
    </Link>
  );
};

export default InboxItem;
